import Const from 'constants';

class SimplexLineupModel {
    constructor(lineup, processData) {
        this.originalLineup = [...lineup];

        const elements = {};
        lineup.map((item) => {
            const prefix = item.charAt(0);

            elements[prefix] ??= {
                raw: [],
                splitted: [],
                distilled: [],
            };

            elements[prefix].raw.push(item);

            const splitted = item.replace(prefix, '').split(Const.LP_ITEM_DELIMITER);

            elements[prefix].splitted.push(splitted);
            elements[prefix].distilled.push(splitted[0]);
        });

        this.elements = elements;
        this.processData = processData;
    }

    getOriginalLineup() {
        return [...this.originalLineup];
    }

    getId() {
        return this.processData.lineupId;
    }

    getEntryId() {
        return this.processData.entryId;
    }

    getRaw(key) {
        return this.elements?.[key]?.raw ?? [];
    }

    getSplitted(key) {
        return this.elements?.[key]?.splitted ?? [];
    }

    getDistilled(key) {
        return this.elements?.[key]?.distilled ?? [];
    }

    hasUnits() {
        return this.getUnits().length > 0;
    }

    getUnits() {
        return this.getRaw(Const.LP_UNIT_PREFIX);
    }

    getPlayerIds() {
        return this.getDistilled(Const.LP_UNIT_PREFIX);
    }

    getTeamGroups() {
        return this.getRaw(Const.LP_TEAM_GROUP_PREFIX);
    }

    getTeamNames() {
        return this.getDistilled(Const.LP_TEAM_GROUP_PREFIX);
    }

    getSubGroupTeamNames() {
        return this.getDistilled(Const.LP_SUBGROUP_PREFIX);
    }
}

export default SimplexLineupModel;
